import React from 'react';
import { EquipmentWrapper } from '../Equipment/EquipmentWrapper';
import { ServiceRequest } from '../ServiceRequest/ServiceRequest';
import { ScheduleRemoteCheck } from '../RemoteCheck/ScheduleRemoteCheck';

export const getTabContent = (
  config,
  data,
  country,
  labels,
  lang,
  leftData,
  rightData,
  unknownData,
  rcData,
  rcRemoteModuleKey,
  useModuleFederationSR,
  providerRegion,
  patientId,
) => {
  const children = [
    <EquipmentWrapper
      config={config}
      data={data}
      labels={labels}
      leftData={leftData}
      rightData={rightData}
      unknownData={unknownData}
    />,
  ];

  if (config.serviceRequestConfig.enabled) {
    children.push(
      <ServiceRequest
        config={config}
        country={country}
        labels={labels}
        lang={lang}
        useModuleFederationSR={useModuleFederationSR}
        providerRegion={providerRegion}
        patientId={patientId}
      />,
    );
  }

  if (config.remoteCheckConfig?.enabled) {
    children.push(
      <ScheduleRemoteCheck
        rcData={rcData}
        rcRemoteModuleKey={rcRemoteModuleKey}
        config={config.remoteCheckConfig}
      />,
    );
  }

  return children;
};
